export default __webpack_public_path__ + "static/media/p2-bg.42607257.png";